<template>
  <el-card>
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="主题:" >
        <el-input v-model="searchFactor.examTheme" style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="团队:" >
        <el-select v-model="searchFactor.deptId" style="width:150px" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in searchFactor.deptOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名:" >
        <el-input v-model="searchFactor.usrName" style="width:100px"></el-input>
      </el-form-item>
      <el-form-item label="姓名:" >
        <el-input v-model="searchFactor.fullName" style="width:100px"></el-input>
      </el-form-item>
      <el-form-item label="考试状态:" >
        <el-select style="width:100px"  v-model="searchFactor.examState" >
          <el-option label="全部" value=""></el-option>
          <el-option label="未开考" value="1"></el-option>
          <el-option label="已开考" value="2"></el-option>
          <el-option label="已结束" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考生状态:" >
        <el-select style="width:100px"  v-model="searchFactor.usrState" >
          <el-option label="全部" value=""></el-option>
          <el-option label="未答题" value="1"></el-option>
          <el-option label="答题中" value="2"></el-option>
          <el-option label="已交卷" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考试结果:" >
        <el-select style="width:100px" v-model="searchFactor.result" >
          <el-option label="全部" value=""></el-option>
          <el-option label="未通过" value="0"></el-option>
          <el-option label="通过" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      ref="multipleTable"
      :highlight-current-row ="false"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="examTheme"
        label="主题"
        min-width="120px" >
      </el-table-column>
      <!-- <el-table-column
        prop="moduleName"
        label="模块"
        min-width="80px" >
      </el-table-column> -->
      <el-table-column
        prop="beginTime"
        label="考试起止时间"
        min-width="120px" :formatter="formatExamTime">
      </el-table-column>
      <el-table-column
        prop="examState"
        label="考试状态"
        min-width="60px">
        <template slot-scope="scope">
          <span v-if = "scope.row.examState == 1" style="color: rgb(25, 0, 255)">未开考</span>
          <span v-else-if="scope.row.examState == 2" style="color: rgb(47, 255, 82)" > 已开考</span>
          <span v-else style="color: rgb(245, 57, 15) " > 已结束</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalScore"
        label="总分数"
        min-width="50px">
      </el-table-column>
      <el-table-column
        prop="passScore"
        label="及格分数"
        min-width="50px">
      </el-table-column>
      <el-table-column
        prop="duration"
        label="考试时长"
        min-width="50px">
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="题目数"
        min-width="50px">
      </el-table-column>
      <el-table-column
        prop="publishUser"
        label="发布者"
        min-width="100px">
      </el-table-column>
      <el-table-column
        prop="publishTime"
        label="发布时间"
        min-width="100px">
      </el-table-column>
      <el-table-column
          prop="fullName"
          label="考生"
          min-width="100px"  :formatter= "formatUserName">
        </el-table-column>
        <el-table-column
          prop="deptName"
          label="团队"
          min-width="100px" >
        </el-table-column>
        <el-table-column
          prop="beginExamTime"
          label="答题时间"
          min-width="120px" :formatter="formatUserExamTime">
        </el-table-column>
        <el-table-column
          prop="score"
          label="分数"
          min-width="60px">
        </el-table-column>
        <el-table-column
          prop="usrState"
          label="考卷状态"
          min-width="60px">
          <template slot-scope="scope">
            <span v-if = "scope.row.usrState == 1" style="color: rgb(25, 0, 255)">未答题</span>
            <span v-else-if="scope.row.usrState == 2 &&  !scope.row.selfExamOver" style="color: rgb(245, 57, 15)" > 答题中</span>
            <span v-else-if="scope.row.usrState == 2 && scope.row.selfExamOver" style="color: rgb(245, 57, 15)" > 超时未交卷</span>
            <span v-else-if = "scope.row.usrState == 3" style="color: rgb(47, 255, 82)" > 已交卷</span>
          </template>
        </el-table-column>
        <el-table-column
        prop="result"
        min-width="80px"
        label="考试结果" >
        <template slot-scope="scope">
            <span v-if = "scope.row.usrState == 3 && scope.row.result == 0" style="color: red"> 未通过</span>
            <span v-else-if = "scope.row.usrState == 3 && scope.row.result == 1" style="color: greenyellow" > 通过</span>
            <span v-else> -
            </span>
          </template>
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"seeOneStudentPaper",index:scope.$index, data:scope.row}'><i class="el-icon-search" style="color:rgb(39, 193, 231)"></i> <span>查看试卷</span></el-dropdown-item>
              <el-dropdown-item v-if = "scope.row.usrState == 3 && scope.row.result == 1" divided :command = '{event:"downLoad",index:scope.$index, data:scope.row}'><i class="el-icon-download" style="color:rgb(43, 255, 0)"></i> <span>下载</span></el-dropdown-item>
              <el-dropdown-item v-if = "scope.row.usrState == 3 && scope.row.result == 1" divided :command = '{event:"print",index:scope.$index, data:scope.row}'><i class="el-icon-printer " style="color:rgb(41, 10, 239)" ></i> <span>打印</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin:10px"
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :current-page="pager.curPage"
      :total="pager.totalCount" >
    </el-pagination>
    <el-dialog :visible.sync="dialogVisual.viewZs" fullscreen v-on:close ="clearZsBox">
     
     <div v-if = "zsBox.zsImage == null  || zsBox.zsImage == ''"   class="zs" ref = "canvasDom">
       <div style="display:block">
         <div style="text-align:left;margin-top:40px">{{zsBox.fullName }}:</div>
         <div style="text-align:left; margin-top:10px;width:800px;text-indent:2em">您在"{{zsBox.theme}}"的考试中表现优秀，成绩合格。</div>
         <div style="text-align:left; margin-top:10px;text-indent:2em">特发此证</div>
         <div style="text-align: left; font-size: 20px;">
           <div style="margin-top:10px; margin-left:550px">天津大学浙江研究院</div>
           <div style="margin-left:570px">{{ zsBox.date }}</div>
         </div>
       </div>
    </div>
    <div  v-else  id = 'zsImage'   style="width:1000px; height: 600px; margin:auto">
     <img :src = "zsBox.zsImage"  style="width:1000px; height: 600px;  margin:auto"/>
    
    </div>
 </el-dialog>
    <!-- 打開一個用戶的試卷 -->
    <el-dialog :visible.sync="dialogVisual.oneStudentPaperVisual" fullscreen  v-on:close ="clearOneStudentPaperViewForm" >
      <el-col :span="7" style="">
        <el-card style="height:calc(25vh - 10px);margin-top: 10px;text-align: left; overflow:auto;">       
          <div  class="clearfix">
            <el-tag type ="warning"  size="mini" >
              {{ viewOneStudentDetail.fullName }}({{viewOneStudentDetail.usrName  }})
            </el-tag>
            <el-tag type ="success"  size="mini">
              {{ viewOneStudentDetail.deptName }}
            </el-tag>
          </div>
          <div  class="clearfix">
            <el-tag type ="mini" >
              {{ viewOneStudentDetail.theme }}
            </el-tag>
            <!-- <el-tag type ="mini">
              {{ viewOneStudentDetail.moduleName }}
            </el-tag> -->
            <el-tag type ="info" size = "mini" v-if="viewOneStudentDetail.examState == 1" >
              未开考
            </el-tag>
            <el-tag type ="success" size = "mini" v-else-if="viewOneStudentDetail.examState == 2" >
              已开考
            </el-tag>
            <el-tag type ="danger" size = "mini" v-else>
              已结束
            </el-tag>
          </div>
          <div  class="clearfix">
            <el-tag type ="info" size = "mini" v-if="viewOneStudentDetail.usrState == 1" >
              未答題
            </el-tag>
            <el-tag type ="success" size = "mini" v-else-if="viewOneStudentDetail.usrState == 2" >
              考试中
            </el-tag>
            <el-tag type ="danger" size = "mini" v-else>
              已交卷
            </el-tag>
            <!-- <el-tag type ='warning' size="mini" v-if="viewOneStudentDetail.usrState == 2" style="cursor: pointer;" @click = sendPaper(viewThemeOneDetail.id)>交卷</el-tag> -->
            <el-tag :type ="viewOneStudentDetail.examResult == 0 ? 'danger': 'success'" size="mini" v-if="viewOneStudentDetail.usrState == 3">
              {{ viewOneStudentDetail.result == 0 ? '不合格': '合格' }}
            </el-tag>
            <el-tag type ="mini" v-if="viewOneStudentDetail.usrState == 3">
              {{ viewOneStudentDetail.score }} 分
            </el-tag>
          </div>
            <div>
              <span style="margin-top : 5px">总分数: {{ viewOneStudentDetail.totalScore }}分; </span>
              <span style="margin-top : 5px">及格分数:{{ viewOneStudentDetail.passScore }}分; </span>
              <span style="margin-top : 5px">考试时长:{{ viewOneStudentDetail.duration }}分钟; </span>
              <div style="margin-top : 5px">注意:少选，多选，错选不得分 </div>
            </div>
        </el-card>
        <el-card style="height:calc(60vh - 10px); text-align: left; margin-top:calc(1vh);overflow:auto;">
          <div v-for = "(item,index) in viewOneStudentDetail.qtList" :key="index" style="margin-top:10px">
            <el-tag type ="mini"> {{item.answerCheckType}}</el-tag><span style="padding-left:10px;">{{'共' +item.qbList.length+ '题,' }}</span>
            <span >{{'每题' +item.oneScore+ '分,'}}</span>
            <span>{{'共' + (item.qbList.length * item.oneScore) + '分' }}</span>
            <el-checkbox-group v-model="viewOneStudentPaperCheckList"  @change="selectedStudentOne">
              <el-checkbox   v-for = "(ite,index) in item.qbList" :key="ite.id"  
              :label="ite.examQuestionId.toString()" :style = "answerCheckList['$$' +ite.examQuestionId ].length  == 0 ? 'color :rgb(208, 82, 82)': 'color:rgb(12, 239, 12)' "> 
                {{index + 1}}  
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-col>
      <el-col :span="17">
        <el-card style="height:calc(86vh - 19px); text-align: left; margin-top:10px;margin-left:20px; overflow:auto;">
          <div slot="header" class="clearfix">
          <el-tag type="warning">{{ qbOneStudentView.uniqNo }}</el-tag>
          <el-tag>{{ qbOneStudentView.moduleName }}</el-tag>
          <el-tag type="success">{{  qbOneStudentView.answerCheckType }}</el-tag>
        </div>
        <div style ="margin-top: 10px;" >
          <el-tag type="warning">问题</el-tag>
          <span style ="margin-left: 10px;">{{qbOneStudentView.question }}</span>
        </div>
        <div style ="margin-top: 10px;" v-if = "qbOneStudentView.imageUrlList.length > 0"> 
          <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
          <el-badge  v-for="(item,index) in qbOneStudentView.imageUrlList" :key = "index"  :value="index + 1" class="item">
            <el-image   
              style="width: 100px; height: 100px;margin-left: 10px; "
              :src="item.url"
              :fit="'fit'"></el-image>
          </el-badge>
          </div>
          <div style ="margin-top: 10px;">
            <el-checkbox-group v-model="answerCheckList['$$' + qbOneStudentView.examQuestionId]" >
              <el-tag type="warning">选项</el-tag>
              <el-checkbox disabled style ="margin-left: 10px;"  v-for="(item,index ) in qbOneStudentView.optionValueArr" :label="index.toString()" :key="index">{{item}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style ="margin-top: 10px;" v-if ="qbOneStudentView.learnAnswer != null && qbOneStudentView.learnAnswer != ''" >
              <el-tag type="warning">考生答案</el-tag>
              <span style ="margin-left: 10px;">{{qbOneStudentView.learnAnswer }}</span>
              <el-button   style ="margin-left: 50px;" size="mini"  :type="qbOneStudentView.learnAnswer == qbOneStudentView.answer ? 'success':'danger'"
               :icon="qbOneStudentView.learnAnswer == qbOneStudentView.answer  ? 'el-icon-check': 'el-icon-close'" circle></el-button>
            </div>
          <div style ="margin-top: 10px;">
            <el-tag type="warning">答案</el-tag>
            <span style ="margin-left: 10px;"> {{qbOneStudentView.answer }}</span>
          </div >
          <div style ="margin-top: 10px;">
            <el-tag type="warning">解析</el-tag>
            <span style ="margin-left: 10px;"> {{qbOneStudentView.analysis }}</span>
          </div>
        </el-card>
      </el-col>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import html2canvas from 'html2canvas'
import {PAGE_SIZE,MESSAGE_DURATION} from  '@/api/constant'
export default {
    name : 'pc_ctr_exam_search',
    data() {
    return {
      searchFactor: {
        examTheme: '',
        deptId : '',
        fullName :'',
        usrName :'',
        result :'',
        usrState:'',
        examState:'',
        deptOptions : []
      },
      dialogVisual:{
        oneStudentPaperVisual : false
      },
      viewOneStudentPaperCheckList:[],
      viewOneStudentDetail: {
        userName:'',
        fullName:'',
        deptName:'',
        id : '',
        theme:'',
        // moduleName :'',
        usrState :'',
        score:'',
        beginExamTime :'',
        commitExamTime :'',
        totalScore:'',
        passScore:'',
        examResult :'',
        duration :'',
        qtList :[]
      },
      qbOneStudentView :{
        examQuestionId :'',
        checkedOptList:[],
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        answerCheckType :'',
        imageUrlList :[]
      },
      answerCheckList:{},
      tableData: [],
      pager:{
        curPage:0,
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      zsBox :{
        fullName :'',
        theme :'',
        date :'',
        zsImage:''
      }
    }
  },

  methods : {
    handleCommand(command){
      let index = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'seeOneStudentPaper' :
          this.seeOneStudentPaper(index,row)
          break
        case 'downLoad':
          this.showZs(index,row)
          break
        case 'print':
          this.printZs(index,row)
          break
      }
    },

    
    printZs(index,item){
      this.dialogVisual.viewZs = true
      this.zsBox.fullName = item.fullName
      this.zsBox.theme = item.examTheme
      let date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      this.zsBox.date = year +'年' + month +'月' + day + '日'
      setTimeout(()=>{ 
      const canvasDom = this.$refs.canvasDom
      html2canvas(canvasDom, {
        dpi: 300, // 解决生产图片模糊
        useCORS: true,
        allowTaint: false,
        logging: false,
        scale: 2,
        windowHeight: 1000
      }).then((canvas) => {
        this.zsBox.zsImage = canvas.toDataURL('image/png')
        setTimeout(()=>{
          const content = document.getElementById('zsImage').innerHTML
          let newWindow = window.open('', '打印窗口');
          newWindow.document.write('<html><head><title>安全考试证书</title></head><body>' + content + '</body></html>');
          newWindow.document.close();
          newWindow.print();
          newWindow.close();
        },200)
      }).catch((e) => {
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })},300)
    },
    clearZsBox(){
      this.zsBox.fullName = ''
      this.zsBox.theme = ''
      this.zsBox.date = ''
      this.zsBox.zsImage = ''
    },
    showZs(index,item){
      this.dialogVisual.viewZs = true
      this.zsBox.fullName = item.fullName
      this.zsBox.theme = item.examTheme
      let date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      this.zsBox.date = year +'年' + month +'月' + day + '日'
      setTimeout(()=>{ 
      const canvasDom = this.$refs.canvasDom
      html2canvas(canvasDom, {
          dpi: 300, // 解决生产图片模糊
          useCORS: true,
          allowTaint: false,
          logging: false,
          scale: 2,
          windowHeight: 1400
        }).then((canvas) => {
          this.zsBox.zsImage = canvas.toDataURL('image/png')      
          let a = document.createElement('a');
          document.body.appendChild(a)
          a.setAttribute("download", `考试证书_${this.zsBox.theme}.png`);
          a.setAttribute("href", this.zsBox.zsImage)
          a.click()
          document.body.removeChild(a) 
        })
        .catch((e) => {
          this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        })
      },1000)
    
    },
    formatExamTime(row, index){
       return   row.beginTime +"/"+  row.endTime
    },

    formatUserName(row, index){
       if(row.userId == null || row.userId == ''){
          return ""
       }
       return  row.fullName +"("+  row.usrName +")"
    },

    formatUserExamTime(row, index){
      let res = ''
      if(row.beginExamTime == null || row.beginExamTime == ''){

        return res
      }
      if(row.commitExamTime == null || row.commitExamTime == ''){

        return row.beginExamTime +"/?"
      }

      return   row.beginExamTime +"/"+  row.endTime

    },
    seeOneStudentPaper(index,row){
      this.dialogVisual.oneStudentPaperVisual = true
      this.viewOneStudentDetail.usrName = row.usrName
      this.viewOneStudentDetail.fullName = row.fullName
      this.viewOneStudentDetail.deptName = row.deptName
      this.handleViewOneStudentPaper(row.userId, row.examId)
    },


    handleViewOneStudentPaper( id, examThemeId){
      let dat = {
        id : examThemeId, student:false,studentId: id
      }
      let url = "/bc/exa/exam/getExamThemeOneDetail"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          let dat = response.data.data
          this.viewOneStudentDetail.state = dat.state
          this.viewOneStudentDetail.score = dat.score
          this.viewOneStudentDetail.usrState = dat.usrState
          this.viewOneStudentDetail.result = dat.result
          this.viewOneStudentDetail.examState = dat.examState
          this.viewOneStudentDetail.beginExamTime = dat.beginExamTime
          this.viewOneStudentDetail.commitExamTime = dat.commitExamTime
          this.viewOneStudentDetail.examResult = dat.examResult
          this.viewOneStudentDetail.id = dat.id
          this.viewOneStudentDetail.theme = dat.theme
          this.viewOneStudentDetail.totalScore = dat.totalScore
          this.viewOneStudentDetail.passScore = dat.passScore
          this.viewOneStudentDetail.duration = dat.duration
          this.viewOneStudentDetail.qtList.splice(0)
          this.viewOneStudentDetail.qtList = [... dat.qtList]
          this.viewOneStudentPaperCheckList = []
          let first = this.viewOneStudentDetail.qtList[0].qbList[0].examQuestionId
          for(let  i = 0 ;i< this.viewOneStudentDetail.qtList.length ; i++){
            let qt =this.viewOneStudentDetail.qtList[i]
            for(let  j = 0 ;j< qt.qbList.length ; j++){
              let qb = qt.qbList[j]
              let arr = []
              if(dat.state >  1 && qb.learnAnswer != null && qb.learnAnswer != ''){
                arr = [... qb.learnAnswer]
              }
              this.$set(this.answerCheckList,'$$' + qb.examQuestionId,arr)
            }
          }
          setTimeout(()=> this.handleViewOneStudentQb(first.toString()),300)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
   
    onSearch(){
      this.examListLoad(1)
    },
    examListLoad(pageNo){
      let url = "/bc/exa/exam/selectUserExamPage"
      let  {
        examTheme,
        deptId ,
        fullName ,
        usrName,
        result ,
        examState,
        usrState } =  this.searchFactor
      let dat = {
        student:false,
        deptId ,
        fullName ,
        usrName,
        examState,
        result ,
        usrState,
        examTheme,
        pageNo,pageSize : PAGE_SIZE}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.tableData.splice(0)
            response.data.data.data.forEach(t=>{
              this.tableData.push(t)
            })
            this.pager.curPage = pageNo
            this.pager.totalCount = response.data.data.totalDataCount
          }else{
            this.$message({
              showClose: true,
              message: '未查询到考生信息！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    selectedStudentOne( val){
      this.clearViewOneStudentQbForm()
      if(this.viewOneStudentPaperCheckList.length == 0){
          return
      }
      let last= this.viewOneStudentPaperCheckList.pop();
      this.viewOneStudentPaperCheckList = []
      setTimeout(()=> this.handleViewOneStudentQb(last),300)
    },

    handleViewOneStudentQb(last){
      this.viewOneStudentPaperCheckList.push(last)
      let row = '';
      let qtList = this.viewOneStudentDetail.qtList
      for(let i = 0; i< qtList.length ; i++){
        let qbList = qtList[i].qbList
        for(let j = 0; j < qbList.length; j++  ){
          if( qbList[j].examQuestionId == last ){
            row = qbList[j]
            break
          }
        }
      }
      this.qbOneStudentView.learnAnswer = row.learnAnswer
      this.qbOneStudentView.examQuestionId = row.examQuestionId
      this.qbOneStudentView.analysis = row.analysis
      this.qbOneStudentView.answer = row.answer
      this.qbOneStudentView.question = row.question 
      this.qbOneStudentView.moduleName=row.moduleName
      this.qbOneStudentView.uniqNo=row.uniqNo
      this.qbOneStudentView.answerCheckType =row.answerCheckType
      this.qbOneStudentView.optionValueArr.splice(0)
      for(let i = 0; i< 5; i++){
        let v =  row['option' + (i + 1)]
        if(v != null &&  v != '') {
          let ch = String.fromCharCode(i + 1 + 64)
          this.qbOneStudentView.optionValueArr.push(ch + "."+ v + ";")
        }
      }
      let countImage = row.countImage 
      this.qbOneStudentView.imageUrlList.splice(0)
      for(let i = 0; i< countImage; i++){
        this.qbOneStudentView.imageUrlList.push({name: row.id , url : row['fileUrl'+ (i+1)]})
      }
    },
    
    clearViewOneStudentQbForm(){
      this.qbOneStudentView.learnAnswer = ''
      this.qbOneStudentView.analysis = ''
      this.qbOneStudentView.answer = ''
      this.qbOneStudentView.question = ''
      this.qbOneStudentView.examQuestionId = ''
      this.qbOneStudentView.moduleName = ''
      this.qbOneStudentView.uniqNo= ''
      this.qbOneStudentView.answerCheckType = '' 
      this.qbOneStudentView.optionValueArr.splice(0)
      this.qbOneStudentView.imageUrlList.splice(0)
    },

    clearOneStudentPaperViewForm(){
      // this.viewOneStudentDetail.moduleName = ''
      this.viewOneStudentDetail.fullName = ''
      this.viewOneStudentDetail.usrName = ''
      this.viewOneStudentDetail.deptName = ''
      this.viewOneStudentDetail.usrState = ''
      this.viewOneStudentDetail.score = ''
      this.viewOneStudentDetail.beginExamTime = ''
      this.viewOneStudentDetail.commitExamTime = ''
      this.viewOneStudentDetail.examResult = ''
      this.viewOneStudentDetail.id = ''
      this.viewOneStudentDetail.theme = ''
      this.viewOneStudentDetail.totalScore = ''
      this.viewOneStudentDetail.passScore = ''
      this.viewOneStudentDetail.duration = ''
      this.viewOneStudentDetail.qtList.splice(0)
      this.clearViewOneStudentQbForm()
    },

    indexMethod(index){
      return  index + 1
    },
   
    handleCurrentChange(val){
      this.examListLoad(val);
    },

    formatGentle(row, index){
      if(row.gentle == 1){
          return '男';
      }else{
          return '女';
      }
    },
    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat = {}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.length !== 0){
            response.data.data.forEach(t=>{
              if(t.level == 1){
                this.searchFactor.deptOptions.push({value: t.id,label: t.deptName })
              }
            })
          }else{
            this.$message({
              showClose: true,
              message: '团队列表未查询到数据！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }
  },
  
  created () {
    setTimeout(()=>{this.deptListLoad(1)},200)
    this.examListLoad(1);
  },
  mounted(){
    
  },
  components: {
    
  }
}
</script>

<style lang="less" scoped>
 
.item {
  margin-top: 10px;
  margin-right: 15px;
}
.zs {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: 700;
  height: 580px; 
  width:1000px;
  background-repeat: no-repeat;
  background-size: 100% 100%; 
  background-image: url('../../assets/image/zs.png');
}
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

.text {
  font-size: 14px;
  color: #000;
}

/deep/.el-progress-bar {


  width : 50%
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_exam_search.vue